import { render } from "./SingleDiamond.vue?vue&type=template&id=3ff73fc3&bindings={}"
import script from "./SingleDiamond.vue?vue&type=script&lang=ts"
export * from "./SingleDiamond.vue?vue&type=script&lang=ts"

import "@/styles/app.css?vue&type=style&index=0&lang=css"
import "./SingleDiamond.vue?vue&type=style&index=1&lang=css"
script.render = render

export default script